import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex flex-col items-center space-y-4">
      <div className="relative">
        {/* Spinner principal */}
        <div className="w-12 h-12 border-4 border-dark-accent border-t-dark-text rounded-full animate-spin"></div>
        
        {/* Spinner secundario */}
        <div className="absolute inset-0 w-12 h-12 border-4 border-transparent border-r-purple-500 rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}></div>
      </div>
      
      <div className="text-center">
        <p className="text-white font-medium">Cargando autos...</p>
        <p className="text-gray-400 text-sm">Conectando con la base de datos</p>
      </div>
      
      {/* Puntos animados */}
      <div className="flex space-x-1">
        <div className="w-2 h-2 bg-dark-text rounded-full animate-bounce"></div>
        <div className="w-2 h-2 bg-dark-text rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
        <div className="w-2 h-2 bg-dark-text rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
      </div>
    </div>
  );
};

export default LoadingSpinner;